// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2XHBV","colMaxWidth":"Table_colMaxWidth__hkzFT"};